import React from 'react'
import IgConnectBenefits from './IgConnectBenefits'
import { IG_HELPDESK_URL, INIT_IG_AUTH_ROUTE } from '../../constants/constants'
import { debug } from '../../services/api/auth'

const helpTopics = [
    {
        title: "OAuthException: Your account's future activity history of Meta technologies is currently turned off.",
        href: `${IG_HELPDESK_URL}/oauth-exception-your-activity-off-meta-technologies`,
    },
    {
        title: "Password is not correct",
        href: `${IG_HELPDESK_URL}/password-not-correct`,
    }
]


const ConnectIGComponent: React.FC<{ connect?: () => void, error: any, status: string }> = ({ connect, error, status }) => {

    const viewHelpClickHandler = (topic = 'View More Topics') => {
        debug({ status: 'View Help', topic, error, path: window.location.pathname, origin: window.location.origin });
    }

    return (
        <div className="position-relative h-100 auth-content-inner">
            <h4 className="pop w-100 text-center auth-heading">Connect Instagram</h4>
            {
                error ? (
                    <>
                        <div className="my-2 p-3 text-danger text-center shadow-none">
                            {
                                error ? (typeof error === 'string' ? (<span dangerouslySetInnerHTML={{__html: error}}></span>) : (error?.message ? (<span dangerouslySetInnerHTML={{__html: error.message}}></span>) : 'Failed to  linkInstagram account')) : null
                            }
                        </div>

                        <div className="help-section">
                            <span className='help-section-text'>Having Trouble Connecting?</span>
                            <div className="help-items">
                                {
                                    helpTopics.map((helpTopic) => (
                                        <a onClick={() => viewHelpClickHandler(helpTopic.title)} href={helpTopic.href} target='_blank' rel='noreferrer' key={helpTopic.href} className="help-item">
                                            <span className='help-item-title'>{helpTopic.title}</span>
                                            <span>
                                                <svg width="25" height="12" viewBox="0 0 25 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M24.5303 6.53033C24.8232 6.23744 24.8232 5.76256 24.5303 5.46967L19.7574 0.696699C19.4645 0.403806 18.9896 0.403806 18.6967 0.696699C18.4038 0.989593 18.4038 1.46447 18.6967 1.75736L22.9393 6L18.6967 10.2426C18.4038 10.5355 18.4038 11.0104 18.6967 11.3033C18.9896 11.5962 19.4645 11.5962 19.7574 11.3033L24.5303 6.53033ZM0 6V6.75H24V6V5.25H0V6Z" fill="#007AFF" />
                                                </svg>
                                            </span>
                                        </a>
                                    ))
                                }
                                <a onClick={() => viewHelpClickHandler()} href={IG_HELPDESK_URL} target='_blank' rel='noreferrer' className="help-item">
                                    <span className='help-item-title'>View More Topics</span>
                                    <span>
                                        <svg width="25" height="12" viewBox="0 0 25 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M24.5303 6.53033C24.8232 6.23744 24.8232 5.76256 24.5303 5.46967L19.7574 0.696699C19.4645 0.403806 18.9896 0.403806 18.6967 0.696699C18.4038 0.989593 18.4038 1.46447 18.6967 1.75736L22.9393 6L18.6967 10.2426C18.4038 10.5355 18.4038 11.0104 18.6967 11.3033C18.9896 11.5962 19.4645 11.5962 19.7574 11.3033L24.5303 6.53033ZM0 6V6.75H24V6V5.25H0V6Z" fill="#007AFF" />
                                        </svg>
                                    </span>
                                </a>
                            </div>
                        </div>

                        <div className="connect-ig-action mt-4">
                            <a href={INIT_IG_AUTH_ROUTE} className="new-ui-btn w-100">
                                <span className='me-1'>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.60426 5.60414L5.07393 5.07381V5.07381L5.60426 5.60414ZM4.33788 6.87052L3.58789 6.87429C3.58996 7.28556 3.92285 7.61844 4.33411 7.62051L4.33788 6.87052ZM6.87967 7.6333C7.29387 7.63539 7.63134 7.30129 7.63343 6.88708C7.63551 6.47287 7.30141 6.1354 6.8872 6.13332L6.87967 7.6333ZM5.07508 4.3212C5.073 3.90699 4.73553 3.5729 4.32132 3.57498C3.90711 3.57706 3.57302 3.91453 3.5751 4.32874L5.07508 4.3212ZM3.82673 10.7849C3.88298 10.3745 3.5959 9.99627 3.18553 9.94002C2.77515 9.88377 2.39687 10.1708 2.34062 10.5812L3.82673 10.7849ZM18.332 5.6681L18.8624 5.13777C15.0422 1.31758 8.86885 1.27889 5.07393 5.07381L5.60426 5.60414L6.13459 6.13447C9.3337 2.93536 14.5572 2.95395 17.8017 6.19843L18.332 5.6681ZM5.66822 18.3319L5.13789 18.8622C8.95808 22.6824 15.1314 22.7211 18.9263 18.9262L18.396 18.3959L17.8657 17.8655C14.6665 21.0646 9.44303 21.0461 6.19855 17.8016L5.66822 18.3319ZM18.396 18.3959L18.9263 18.9262C22.7212 15.1313 22.6825 8.95796 18.8624 5.13777L18.332 5.6681L17.8017 6.19843C21.0462 9.44291 21.0648 14.6664 17.8657 17.8655L18.396 18.3959ZM5.60426 5.60414L5.07393 5.07381L3.80755 6.34019L4.33788 6.87052L4.86821 7.40085L6.13459 6.13447L5.60426 5.60414ZM4.33788 6.87052L4.33411 7.62051L6.87967 7.6333L6.88343 6.88331L6.8872 6.13332L4.34165 6.12053L4.33788 6.87052ZM4.33788 6.87052L5.08787 6.86675L5.07508 4.3212L4.32509 4.32497L3.5751 4.32874L3.58789 6.87429L4.33788 6.87052ZM3.08368 10.6831L2.34062 10.5812C1.93919 13.5099 2.87404 16.5984 5.13789 18.8622L5.66822 18.3319L6.19855 17.8016C4.27798 15.881 3.48676 13.2652 3.82673 10.7849L3.08368 10.6831Z" fill="white" />
                                    </svg>
                                </span>
                                Retry
                            </a>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="ig-connection-description">
                            <span>Connecting your Instagram will help us connect you wth right campaign</span>
                        </div>
                        <div className="ig-connection-benefits">
                            <h6 className="ig-connection-heading">What benefits you will get</h6>
                            <IgConnectBenefits />
                        </div>
                        <div className="bottom-section">
                            {
                                connect ? (
                                    <button className="new-ui-btn w-100" onClick={connect}>{status}</button>
                                ) : null
                            }
                        </div>
                    </>
                )
            }


        </div>
    )
}

export default ConnectIGComponent